import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '@core/components/navbar/navbar.component';
import { ErrorModalComponent } from '@shared/error-modal/error-modal.component';
import { CnfpcToastComponent } from '@shared/ui/cnfpc-toast/cnfpc-toast.component';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    RouterOutlet,
    ErrorModalComponent,
    CnfpcToastComponent,
  ],
  template: `
    @if (showApp) {
      <app-navbar></app-navbar>
      <main
        class="min-h-screen bg-gradient-to-r from-cnfpc-primary-darkest to-cnfpc-primary-dark pt-24"
      >
        <router-outlet></router-outlet>
      </main>
      <app-cnfpc-toast></app-cnfpc-toast>
      <app-error-modal />
    } @else {
      <div
        class="fixed inset-0 flex items-center justify-center bg-cnfpc-primary-darker"
      >
        <div class="text-center text-white">
          <div
            class="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-white"
          ></div>
          <h2 class="mb-2 text-xl font-semibold">ERP Formations</h2>
          <p>Connexion en cours...</p>
        </div>
      </div>
    }
  `,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly msalService = inject(MsalService);

  title = 'erp-front-office';
  showApp = false;

  ngOnInit(): void {
    this.checkAuthentication();
  }

  private async checkAuthentication(): Promise<void> {
    try {
      // Vérification immédiate des comptes existants pour un affichage rapide
      const existingAccounts = this.msalService.instance.getAllAccounts();

      if (existingAccounts.length > 0) {
        this.msalService.instance.setActiveAccount(existingAccounts[0]);
        this.showApp = true;

        if (window.location.pathname === '/') {
          window.history.replaceState(null, '', '/home');
        }
        return;
      }

      // Attendre que MSAL soit prêt pour traiter les redirections
      await new Promise((resolve) => setTimeout(resolve, 500));

      const redirectResponse =
        await this.msalService.instance.handleRedirectPromise();

      if (redirectResponse) {
        this.msalService.instance.setActiveAccount(redirectResponse.account);
        this.showApp = true;

        if (window.location.pathname === '/') {
          window.history.replaceState(null, '', '/home');
        }
        return;
      }

      // Redirection vers Microsoft pour la connexion
      this.msalService.loginRedirect({
        scopes: ['user.read'],
        redirectUri: window.location.origin,
      });
    } catch (error) {
      // Fallback en cas d'erreur
      setTimeout(() => {
        this.msalService.loginRedirect({
          scopes: ['user.read'],
          redirectUri: window.location.origin,
        });
      }, 1000);
    }
  }
}
